/* eslint-disable */
// reducers
import {
  JOURNEY_LISTING,
    TOGGLE_LOADING,
    UNAUTHORIZED_JOURNEY,
  } from "../../constants/JourneyActionTypes";
  
const initialState = {
    loading: false,
    unAuthorisedJourney:null,
    journeyListing:null
  };
  
  const accountReducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case TOGGLE_LOADING:
            return { ...state, loading: payload };
      case UNAUTHORIZED_JOURNEY:
            return { ...state, unAuthorisedJourney: payload };
      case JOURNEY_LISTING:
            return { ...state, journeyListing: payload };
      default:
        return state;
    }
  };
  export default accountReducer;  